import { gql } from "@apollo/client";

export const GET_CONCERT_MENU = gql`
  query concertPrograms($limit: Int, $sort: String) {
    concertPrograms(limit: $limit, sort: $sort) {
      id
      title
      created_at
      feat_img {
        url
      }
    }
  }
`;

export const GET_CONCERT_PROGRAM = gql`
  query concertProgram($id: ID!) {
    concertProgram(id: $id) {
      id
      title
      description
      feat_img {
        url
      }
      created_at
      concert_videos {
        id
        title
        url
        created_date
      }
    }
  }
`;
